import { CalendarClock, ClipboardCheck, Scale, Tag } from "lucide-react";
import InfoContentSection from "@cle/components/InfoContentSection";

/**
 * The status names match `getStatusPresentation` in AfgorelserTable verbatim.
 *
 * The TODOs below mark the sentences that need the secretariat's wording before this
 * ships.
 */
const AfgorelserInfoContent = () => {
  return (
    <div className="d-flex flex-column gap-3">
      <InfoContentSection icon={Scale} title="Påbud og pålæg">
        Kolonnen Type viser, om afgørelsen er et påbud eller et pålæg.
        {/* TODO(sekretariatet): tilføj én sætning om hver — forskellen mellem
            påbud og pålæg i medlemsvendte ord. Tabellens første kolonne viser
            netop disse to værdier, så forskellen bør stå her. */}
      </InfoContentSection>

      <InfoContentSection
        icon={CalendarClock}
        title="Dokumentationsperiode og indberetningsfrist"
      >
        Dokumentationsperioden er det tidsrum, din dokumentation skal ligge
        inden for. Indberetningsfristen er den dato, hvor indberetningen skal
        være indsendt. Begge løber kun, mens du er udøvende advokat: har du
        deponeret din beskikkelse, står de stille og fortsætter, når
        beskikkelsen bliver genudleveret.
      </InfoContentSection>

      <InfoContentSection
        icon={ClipboardCheck}
        title="Lektionskrav og indberettede lektioner"
      >
        Lektionskravet er det antal lektioner, afgørelsen kræver. Indberettede
        lektioner er, hvor mange du har indsendt på afgørelsen indtil nu.
        {/* TODO(sekretariatet): tæller lektioner indberettet på en afgørelse
            også med i den almindelige efteruddannelsesperiode? */}
      </InfoContentSection>

      <InfoContentSection icon={Tag} title="Status">
        <em>Afventer indberetning</em> — der er oprettet en indberetning, du kan
        udfylde og indsende. <em>Indsendt</em> — du har indberettet og signeret.
        <em>I bero</em> — fristen står stille, fordi din beskikkelse er
        deponeret; den genoptages ved genudlevering. <em>Under behandling</em> —
        afgørelsen ligger hos Advokatsamfundet, og du skal ikke foretage dig
        noget lige nu.
      </InfoContentSection>
    </div>
  );
};

export default AfgorelserInfoContent;
